import getters from './getters'
import actions from './actions';
import mutations from './mutations';
const state = {
    authenticated: false,
    loggedInUser: {},
    user: {
        firstName: '',
        lastName: '',
        roleId: '',
        gender: 'male',
        phone: '',
        email: '',
        // nearBy: '',
        age: '',
        // flatNumber: '',
        // buildingName: '',
        // locality: '',
        // pinCode : '',
        creditLimit : 0,
        // profileImage : ''
        preferredProductPriceType: 'Retail',
        customerTypes: 'person',
        branchId: null,
        metaData: {
            gstNumber: '',
            societyName : '',
            district : '',
            road : '',
            societyInformation: [
                {
                    label: 'Chairman Name'
                },
                {
                    label: 'Secretary Name'
                },
                {
                    label: 'Manager Name'
                }
            ],
            firmInformation : [
                {
                    label : 'Owner'
                },
                {
                    label : 'Manager'
                }
            ]
        },
        firstNameMarathi: '',
        lastNameMarathi: '',
        // buildingNameMarathi: '',
        // localityMarathi: '',
        // nearByMarathi: '',
        // societyNameMarathi: '',
        addresses:[
          {
            address: '',
            addressMarathi: ''
          }
        ]
    },
    userList: {},
    customerList: {},
    userQuotations: [],
    userQuotationMeta: {}
}

const user = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}

export default user;
